import { useEffect, useState } from 'react';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/fb848677fb13893b15c5c6af947ad085.jpeg"
          alt="Surfing in Essaouira"
          className="w-full h-full object-cover object-top scale-105"
          style={{ animation: 'heroZoom 12s ease-out forwards' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs font-semibold tracking-widest uppercase px-5 py-2 rounded-full mb-8 transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transitionDelay: '0ms'
          }}
        >
          <span className="w-1.5 h-1.5 bg-teal-400 rounded-full animate-pulse inline-block"></span>
          Essaouira, Maroc · Surf & Kitesurf
        </div>

        {/* Title */}
        <h1
          className="text-6xl md:text-8xl font-bold text-white leading-none mb-6 tracking-tight transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transitionDelay: '150ms'
          }}
        >
          Ride the<br />
          <span className="text-teal-400">Atlantic.</span>
        </h1>

        {/* Subtitle */}
        <p
          className="text-lg md:text-xl text-white/80 mb-10 max-w-xl mx-auto font-light leading-relaxed transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transitionDelay: '300ms'
          }}
        >
          Cours de surf & kitesurf avec des instructeurs certifiés. Débutants bienvenus.
        </p>

        {/* CTAs */}
        <div
          className="flex flex-wrap gap-4 justify-center transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transitionDelay: '450ms'
          }}
        >
          <a
            href="/contact"
            className="bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 shadow-lg hover:shadow-teal-500/40 hover:shadow-xl hover:-translate-y-0.5 cursor-pointer"
          >
            Réserver maintenant
          </a>
          <a
            href="/surf-lessons"
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 border border-white/30 text-white px-8 py-4 rounded-full font-semibold text-sm whitespace-nowrap transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
          >
            Découvrir les cours
          </a>
        </div>

        {/* Stats */}
        <div
          className="flex items-center justify-center gap-10 mt-16 transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transitionDelay: '600ms'
          }}
        >
          {[
            { value: '500+', label: 'Élèves formés' },
            { value: '10 ans', label: "D'expérience" },
            { value: '300j', label: 'De soleil/an' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl font-bold text-white">{stat.value}</p>
              <p className="text-xs text-white/60 mt-0.5 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 opacity-60">
        <span className="text-white text-xs tracking-widest uppercase">Scroll</span>
        <div className="w-px h-10 bg-white/40 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full bg-white" style={{ animation: 'scrollLine 1.8s ease-in-out infinite', height: '40%' }}></div>
        </div>
      </div>

      <style>{`
        @keyframes heroZoom {
          from { transform: scale(1.05); }
          to { transform: scale(1); }
        }
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(300%); }
        }
      `}</style>
    </section>
  );
}
